import React, {Component} from 'react';
import {Table, Column, Cell} from 'fixed-data-table-2';
import Dimensions from 'react-dimensions';
import Filter from './Filter';
import 'react-table-filter/lib/styles.css';

export class TableGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columnWidths     : {},
            "rowData"        : props.data,
            "defaultRowData" : {
                "colorwayName"                : "",
                "nikeDevColorwayType"         : "",
                "lineEvolutionDescription"    : "",
                "nikeDevColorwaySeasonStatus" : "",
                "nikeProductOfferingId"       : "",
                "nikeProductID"               : "",
                "nikeDevColorwayID"           : "",
                "cycleYearAbbreviation"       : ""
            }
        };
        this._filterUpdated = this._filterUpdated.bind(this);
        this._onColumnResizeEndCallback = this._onColumnResizeEndCallback.bind(this);
    }

    _onColumnResizeEndCallback = (newColumnWidth, columnKey) => {
        this.setState(({columnWidths}) => ({
            columnWidths : {
                ...columnWidths,
                [columnKey] : newColumnWidth
            }
        }));
    };

    _filterUpdated(newData) {
        this.setState({
            "rowData" : newData
        });
    }


    render() {
        const defaultColWidth = 240;
        const lengthColumn = Object.keys(this.state.defaultRowData).length;
        const maxWidth = lengthColumn * defaultColWidth;
        return (

            <div>
                <Table
                    rowHeight={50}
                    rowsCount={this.state.rowData.length}
                    width={this.props.containerWidth <= maxWidth ? this.props.containerWidth : maxWidth}
                    maxHeight={600}
                    headerHeight={70}
                    onColumnResizeEndCallback={this._onColumnResizeEndCallback}
                    isColumnResizing={false}
                    className="tableGrid"
                >
                    {Object.keys(this.state.defaultRowData).map(columnKey  => (
                        <Column
                            key={columnKey}
                            header={
                                <Filter
                                    key={columnKey}
                                    rowData={this.state.rowData}
                                    columnKey={columnKey}
                                    onFilterUpdate={this._filterUpdated}

                                />

                            }
                            columnKey={columnKey}
                            isResizable={true}
                            cell={({rowIndex, columnKey, ...props}) =>
                                <Cell {...props}
                                    className={(this.state.rowData[rowIndex].devColorwayStatus === 'Inactive' ? 'inactive' : '')}
                                >
                                    {this.state.rowData[rowIndex][columnKey]}
                                </Cell>}
                            width={this.state.columnWidths[columnKey]
                                ? this.state.columnWidths[columnKey]
                                : defaultColWidth}
                        />
                    ))}


                </Table>
            </div>
        );
    }
}

export default Dimensions()(TableGrid);



// WEBPACK FOOTER //
// ./src/Components/TableGrid.js